import React from "react"

const Section = ({ title, aside, children }) => (
  <section>
    <div className="flex items-center justify-between mb-2.5">
      <h3 className="text-[10.5px] font-semibold uppercase tracking-wider text-slate-500 m-0">{title}</h3>
      {aside}
    </div>
    {children}
  </section>
)

export default Section
